module.exports = "/images/es-ib.svg?a05628820fba3bd016f21d8306339fb0";